import { render } from "./MobileView.vue?vue&type=template&id=280ce146&scoped=true"
import script from "./MobileView.vue?vue&type=script&lang=js"
export * from "./MobileView.vue?vue&type=script&lang=js"

import "./MobileView.vue?vue&type=style&index=0&id=280ce146&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280ce146"]])

export default __exports__